import { AnimatedSection } from "./AnimatedSection";

const stats = [
  { value: "$8T+", label: "Global food trade lacks structured pricing visibility" },
  { value: "$2.5T+", label: "Trade finance gap limits growth across markets" },
  { value: "30–90", label: "Day cash cycles slow down expansion" },
  { value: "80%+", label: "Deals still rely on fragmented communication" },
];

export function MarketReality() {
  return (
    <section
      id="market-reality"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="market-reality-section"
    >
      {/* Subtle texture background */}
      <div className="absolute inset-0 z-0 opacity-20">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/6d886167-72b0-4f6c-ba62-cd5d97afce73/images/7be858da785197196e63e5462481bf316db753a66a00b7bb1d30bff3065c33b5.png"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
            Market Reality
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white max-w-3xl">
            A massive system still running on inefficiency
          </h2>
        </AnimatedSection>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1A2E22]/50">
          {stats.map((stat, i) => (
            <AnimatedSection key={i} delay={i * 0.1}>
              <div className="bg-[#09120D] p-8 md:p-10 h-full">
                <span className="font-['Outfit'] text-4xl lg:text-5xl font-bold text-[#22C55E]">
                  {stat.value}
                </span>
                <p className="mt-4 text-[#A1B2A8] text-sm leading-relaxed">
                  {stat.label}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
